import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Groups as GroupsIcon, Circle as CircleIcon } from '@mui/icons-material';
import { Get_All_TeamLeaders_and_Sales__By_Managers_Email_Action } from '../Redux/Actions/SalesAction';
import { useTheme, useMediaQuery } from '@mui/material';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─── Design tokens — matches ManagerDashboard / SalesQuickNumberCRMData ──── */
const C = {
  bg: '#F7F8FC',
  white: '#FFFFFF',
  border: '#E8EAF0',
  accent: '#0D47A1',
  accentSoft: 'rgba(13,71,161,0.07)',
  text: '#1C2340',
  textMuted: '#7B829A',
  success: '#12B76A',
  warning: '#F79009',
  danger: '#F04438',
  shadow: '0 1px 3px rgba(16,24,40,0.08)',
  shadowMd: '0 4px 16px rgba(16,24,40,0.10)',
};

const FONT = "'DM Sans', sans-serif";
const SIDEBAR_COLLAPSED = 64;

export const MyTeamLeadersForManagers = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع الحالي (dark/light)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const sidebarW = useSidebarWidth();

  const dispatch = useDispatch();
  const [userlogin] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  useEffect(() => {
    if (userlogin?.data?.email) {
      dispatch(Get_All_TeamLeaders_and_Sales__By_Managers_Email_Action(userlogin.data.email));
    }
  }, [userlogin, dispatch]);

  const resgetdata = useSelector((state) => state.AllSales.TeamLeadersandsalesformanger);
  const teamleaderandsalesarray = Array.isArray(resgetdata?.data) ? resgetdata.data : [];

  return (
    <div
      style={{
        marginLeft: isMobile ? SIDEBAR_COLLAPSED : sidebarW,
        marginTop: 64,
        minHeight: 'calc(100vh - 64px)',
        background: C.bg,
        fontFamily: FONT,
        transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
      }}
    >
      <Container fluid className="fade-in" style={{ padding: '28px 24px 48px', maxWidth: '100%' }}>
        {/* ── Header ── */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <GroupsIcon sx={{ color: C.accent, fontSize: 22 }} />
          <span
            style={{
              fontSize: 24,
              fontWeight: 800,
              color: C.text,
              letterSpacing: '-0.02em',
              fontFamily: FONT,
            }}
          >
            My Team Leaders
          </span>
        </div>
        <div style={{ fontSize: 13.5, color: C.textMuted, fontFamily: FONT, marginBottom: 24 }}>
          This is the page where you can see your team leaders and sales that are related with you.
        </div>

        {/* ── Team leader cards ── */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
            gap: 16,
          }}
        >
          {teamleaderandsalesarray.map((items, index) => (
            <div
              key={index}
              style={{
                background: C.white,
                border: `1px solid ${C.border}`,
                borderRadius: 12,
                boxShadow: C.shadow,
                overflow: 'hidden',
                transition: 'transform 0.15s, box-shadow 0.15s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = C.shadowMd;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = C.shadow;
              }}
            >
              {/* Card header */}
              <div
                style={{
                  padding: '16px 20px',
                  borderBottom: `1px solid ${C.border}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  background: C.accentSoft,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      background: C.accent + '15',
                      border: `1px solid ${C.accent}30`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <GroupsIcon sx={{ color: C.accent, fontSize: 20 }} />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: 700,
                        color: C.text,
                        fontFamily: FONT,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {items.teamleader?.name || 'N/A'}
                    </div>
                    <div style={{ fontSize: 11.5, color: C.textMuted, fontFamily: FONT }}>
                      {items.teamleader?.role || 'N/A'}
                    </div>
                  </div>
                </div>

                {items.teamleader?.active && (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                      background: C.success + '15',
                      color: C.success,
                      border: `1px solid ${C.success}30`,
                      padding: '4px 10px',
                      borderRadius: 20,
                      fontSize: 11.5,
                      fontWeight: 700,
                      fontFamily: FONT,
                      flexShrink: 0,
                    }}
                  >
                    <CircleIcon sx={{ fontSize: 8 }} />
                    Active
                  </span>
                )}
              </div>

              {/* Card body */}
              <div style={{ padding: '16px 20px' }}>
                <div style={{ marginBottom: 14 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: C.textMuted, fontFamily: FONT }}>
                    Email
                  </span>
                  <div style={{ fontSize: 13.5, color: C.accent, fontWeight: 600, fontFamily: FONT, marginTop: 2 }}>
                    {items.teamleader?.email || 'N/A'}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    color: C.textMuted,
                    fontFamily: FONT,
                    marginBottom: 8,
                    paddingTop: 12,
                    borderTop: `1px solid ${C.border}`,
                  }}
                >
                  Sales Members
                </div>

                {items.sales.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {items.sales.map((sale, saleIndex) => (
                      <div
                        key={saleIndex}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '8px 12px',
                          background: C.bg,
                          border: `1px solid ${C.border}`,
                          borderRadius: 8,
                        }}
                      >
                        <span style={{ fontSize: 13, color: C.text, fontFamily: FONT, fontWeight: 500 }}>
                          {sale.name}
                        </span>
                        <span style={{ fontSize: 11.5, color: C.textMuted, fontFamily: FONT }}>
                          {sale.city.length > 0 ? sale.city[0].name : 'No City'}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ fontSize: 13, color: C.textMuted, fontStyle: 'italic', fontFamily: FONT }}>
                    No Sales Members
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};
